// extracted by mini-css-extract-plugin
export default {"productsPage":"ProductsPage_productsPage__KNLDO"};